import { Button } from '@pwc/appkit-react';

type ResetIgnoredDiagnosticsButtonProps = {
  isDisabled: boolean;
  onClick: () => void;
  isLoading: boolean;
};

export const ResetIgnoredDiagnosticsButton: React.FC<ResetIgnoredDiagnosticsButtonProps> = ({
  isDisabled,
  onClick,
  isLoading,
}) => {
  return (
    <Button
      size="lg"
      className="add-button"
      disabled={isDisabled}
      onClick={onClick}
      kind="secondary"
      isLoading={isLoading}
    >
      Reset Ignored Diagnostics
    </Button>
  );
};
